import { months } from './constants'

export const mapFAQToStructuredData = faqObject => faqObject.map(faq => {
  return {
    "@type": "Question",
    "name": faq.title,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer.reduce((acc, cur, ind) => {
        switch (cur.type) {
          case 'head':
            return `${acc}<strong>${cur.content}</strong>${ind !== faq.answer.length - 1 ? '<br/>' : ''}`
          case 'para':
            return `${acc}${cur.content}${ind !== faq.answer.length - 1 ? '<br/>' : ''}`
          default:
            return acc
        }
      }, '')
    }
  }
})
export const getFormattedDate = (dateString, showYear = true) => {
  if (dateString) {
    const timeOffset = (new Date().getTimezoneOffset()) * 60000
    const dateObject = new Date(Date.parse(dateString) + timeOffset + 23.5 * 60 * 60 * 1000)
    if (dateObject instanceof Date && !isNaN(dateObject)) {
      return `${months[dateObject.getMonth()]} ${dateObject.getDate()}${showYear ? `, ${dateObject.getFullYear()}` : ''}`
    } else {
      return '[Invalid Date]'
    }
  } else {
    return null
  }
}
export const getStandardDate = dateString => {
  if (dateString) {
    const dateObject = new Date(dateString)
    return dateObject.toLocaleDateString(
      'ko-KR', 
      { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'UTC' }
    ).replaceAll('. ', '-').replaceAll('.', '')
  } else {
    return null
  }
}
// Return an object describing the response, which can be used for setState
export const handleSuccess = (resMessage, additionalState = {}) => ({
  loading: false,
  res: {
    success: true,
    message: resMessage
  },
  ...additionalState
})

// Handle error, and return an object describing the response, which can be used for setState
export const handleError = (errorObject, errorMessages, additionalState = {}) => {
  console.warn(errorObject)
  console.log(errorObject, {
    loading: false,
    res: {
      success: false,
      message: errorMessages[errorObject.response && errorObject.response.status] 
        || errorMessages.default
    },
    ...additionalState
  })
  return {
    loading: false,
    res: {
      success: false,
      message: errorMessages[errorObject.response && errorObject.response.status] 
        || errorMessages.default
    },
    ...additionalState
  }
}
